export const useSelect = ({ onChange, disabled }) => {
  const handleChange = (e) => {
    if (disabled) return;
    if (onChange) {
      onChange(e);
    }
  };

  return {
    handleChange,
  };
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Select/hooks/useSelect.js